<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eJGV0I/tc-custom/9781735879581.jpg?1726574202254" alt="This image is the cover for the book Queen of Belize, Queens of the Castle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Queen of Belize, Queens of the Castle
      </h1>
      <p class="bookDescription body article font2">
        <b>Before taking her first breath, death appeared ready to claim her life.</b> Surviving birthed a calling to be an avenger and equalizer for those who have no voice. When dark forces emerge and threaten not only her life, but the lives of those closest to her, Naysa, Queen of Belize, becomes a foot soldier, calling upon the assistance of allies and a few adversaries to aid in a personal war. It’s then that she fulfills the meaning of her name, glorious war hero.<br/><br/><b>ABOUT THE QUEENS OF THE CASTLE SERIES</b><br/>Each Queen book is a standalone, NO cliffhangers<br/><br/><b><i>USA TODAY</i>, and National Bestselling Authors have created a world where women can—and will have it all—love, family, career, and leave a legacy while overcoming generational challenges.</b><br/><br/>These powerful women, brought together for a higher purpose, change lives by providing safety for those who cannot protect themselves; care for those from tragic backgrounds, and make an impact on their families, communities, and the world at large. <br/><br/>The Kings laid the foundation; the Knights created a bridge of hope between continents; but the Queens will change the world.<br/><br/>Book 1–Queen of Lahiana<br/>Book 2–Queen of Shadow Bay<br/>Book 3–Queen of North Shore<br/>Book 4–Queen of Belize<br/>Book 5–Queen of Kingston<br/>Book 6–Queen of Cambridge<br/>Book 7–Queen of Wilmette<br/>Book 8—Queen of Curaçao<br/>Book 9–Queen of Bahia
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aiken Ponder
      </h2>
      
      <p class="authorDescription body article">Aiken Ponder grew up admiring authors that wielded their pens like a sword. Learning from the masters she too put pen to paper clearing her path to success. Aiken writes across many genres including Erotica, Mysteries, Paranormal, and Adult Contemporary Literature.<br><br>Her debut book, 80 Days of Pleasure is a collaborative work with New York Times and USA Today Bestselling Authors. Aiken's books feature powerful women who unapologetically embrace their authenticity and boldly walk in their purpose and passion.<br><br>You may follow her on all social media sites under Aiken Ponder.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Words to Ponder Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d988268